import axios from 'axios';

const PM_API_BASE = process.env.REACT_APP_PM_API_URL || '';

const pmApi = axios.create({
  baseURL: `${PM_API_BASE}/pm-api`,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
});

// Turbine/Asset endpoints
export const pmAssetsApi = {
  getAll: () => pmApi.get('/assets'),
  getLatest: (assetId) => pmApi.get(`/assets/${assetId}/latest`),
  getHistory: (assetId, hours = 24) => pmApi.get(`/assets/${assetId}/history`, { params: { hours } }),
  score: (scoreRequest) => pmApi.post('/score', scoreRequest),
  updateDateOffset: () => pmApi.post('/assets/update-date-offset'),
  getDateOffsetStatus: () => pmApi.get('/assets/date-offset-status')
};

// Pump endpoints
export const pmPumpApi = {
  getAll: (filters = {}) => pmApi.get('/pump-assets', { params: filters }),
  getLatest: (assetId) => pmApi.get(`/pump-assets/${assetId}/latest`),
  getMaintenanceHistory: (assetId, limit = 50) => pmApi.get(`/pump-maintenance/${assetId}`, { params: { limit } }),
  getNptTrend: (assetId, days = 30) => pmApi.get(`/pump-npt-trend/${assetId}`, { params: { days } }),
  getNptByComponent: () => pmApi.get('/pump-npt-by-component'),
  getNptByFleet: (limit = 20) => pmApi.get('/pump-npt-by-fleet', { params: { limit } }),
  getComponentMtbf: () => pmApi.get('/component-mtbf')
};

// Alerts
export const pmAlertsApi = {
  getAll: (status = 'open') => pmApi.get('/alerts', { params: { status } })
};

// AI Assistant
export const pmAssistantApi = {
  query: (query) => pmApi.post('/assistant/query', { query }),
  chat: (messages, pageContext) => pmApi.post('/assistant/chat', { messages, page_context: pageContext })
};

export default pmApi;
